module.exports = __webpack_public_path__ + "static/media/peas.8eb187dd.png";